import { FC, memo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Wrapper, Section } from './details.styled';
import { Button, SVG, Text } from '../../components-v4';
import { useResponsive } from '../../../../hooks';
import { ReactComponent as ChevronIcon } from '../../assets/chevron-down.svg';
import { getPublicRequestData } from '../../selectors';
import { removeHtmlTags } from '../../utils';

export const Details: FC = memo(() => {
  const { viewport } = useResponsive();
  const [showDetails, setShowDetails] = useState<boolean>(false);
  const requestData = useSelector(getPublicRequestData);

  return (
    <>
      <Button
        size={viewport.mobile ? 'm' : 'l'}
        mode="accent"
        variant="ghost"
        onClick={() => setShowDetails((prev) => !prev)}
        rightIcon={<SVG src={ChevronIcon} props={{ isMirror: showDetails }} />}
        style={{ marginLeft: '-16px' }}
      >
        {showDetails ? 'Скрыть' : 'Подробнее о заявке'}
      </Button>
      {showDetails && (
        <Wrapper>
          <Section>
            <Text
              variant={viewport.mobile ? 'heading-5' : 'heading-4'}
              color="gray.500"
            >
              Адрес
            </Text>
            <Text
              variant={viewport.mobile ? 'body-14' : 'body-16'}
              color="gray.800"
            >
              {requestData.address}
            </Text>
          </Section>
          <Section>
            <Text
              variant={viewport.mobile ? 'heading-5' : 'heading-4'}
              color="gray.500"
            >
              Телефон
            </Text>
            <Text
              variant={viewport.mobile ? 'body-14' : 'body-16'}
              color="gray.800"
            >
              {requestData.tenant_phone}
            </Text>
          </Section>
          <Section>
            <Text
              variant={viewport.mobile ? 'heading-5' : 'heading-4'}
              color="gray.500"
            >
              Описание
            </Text>
            <Text
              variant={viewport.mobile ? 'body-14' : 'body-16'}
              color="gray.800"
            >
              {removeHtmlTags(requestData.description)}
            </Text>
          </Section>
        </Wrapper>
      )}
    </>
  );
});
